import Component from './component.vue';

export * from './const';
export * from './types';
export default Component;



// WEBPACK FOOTER //
// ./src/pages/organizations/list/index.ts